import { axiosPrivate } from "./axios";

export const whyusByApi = async (payloadData) => {
  let res = await axiosPrivate.get("/frontend/whyus", payloadData);
  return res.data;
};
